import { useCurrentUserQuery } from 'src/context/api/auth';

export const getTabs = (role: string | undefined) => {
    const tabs: any = {
        "/": [
            { title: "Workspaces list" }
        ],
        "/404": [
            { title: "404 Not Found" }
        ],
        "/workspaces": [
            { title: "Workspaces list" }
        ],
        "/admin/sso/list": [
            { title: "SSO integrations" }
        ],
        "/admin/users": [
            { title: "Users" },
        ],
        "/account": [
            { title: "Profile" },
        ],
        "/brand-overview": [
            { title: "Brand Overview" },
        ],
        "/competitors-monitoring": [
            { title: "Competitors Monitoring" },
        ],
        "/competitor-focus": [
            { title: "Competitors Focus" },
        ],
        "/text-ads": [
            { title: "Text Ads" },
        ],
        "/product-listing-ads": [
            { title: "Product Listing Ads" },
        ],
        "/brand-wayback": [
            { title: "Brand Wayback" },
        ],
        "/optimization/campaigns": [
            { title: "Campaigns" },
        ],
        "/optimization/overview": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/conversions-analysis": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/funnel": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/traffic-details": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/cluster-manager": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],

        "/optimization/activations/overview": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],

        "/optimization/activations/active-mode": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],

        "/admin/features/live-bidding/ad-group-based": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],
        "/optimization/activations/ko-bidding": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],
        "/optimization/activations/ko-bidding-auto": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],
        "/optimization/scraping": [
            { title: "Activations", label: "Overview", path: "/optimization/activations/overview" },
            { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
            { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
            { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
            { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
        ],
        "/visibility/overview": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/competition-evolution": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/st-analysis": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/ads": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "regexp:^/workspaces/(?<id>[0-9]+)": [
            { title: "Administration" },
        ],
        "/non-branded/search-terms": [
            { title: "Search terms" },
        ],
        "/brand-pulse": [
            { title: "My Competitors", label: "Overview", path: "/brand-pulse/competitors" },
            { title: "My Competitors", label: "Competitors Selection", path: "/brand-pulse/competitors-selection" },
        ],
        "/non-branded/competitors": [
            { title: "Competitors" },
        ],
                "/non-branded/conquest-mode": [
            { title: "Conquest Mode" },
        ],
    };

    if (role?.toLowerCase() !== "admin" && role?.toLowerCase() !== "brand specialist" && role?.toLowerCase() !== "consultant") {
        Object.keys(tabs).forEach((key) => {
            tabs[key] = tabs[key].filter((tab: any) => tab.label !== "Cluster Manager");
        });
    }


    return tabs;
};
